__turbopack_context__.v({
  "card": "ColorCatalogueSection-module__8tflDW__card",
  "cardsContainer": "ColorCatalogueSection-module__8tflDW__cardsContainer",
  "modalContent": "ColorCatalogueSection-module__8tflDW__modalContent",
  "root": "ColorCatalogueSection-module__8tflDW__root",
});
